import { NgModule } from '@angular/core';
import { BouncingBallComponent } from './bouncing-ball.component';

@NgModule({
  declarations: [BouncingBallComponent],
  imports: [
  ],
  exports: [BouncingBallComponent]
})
export class BouncingBallModule { }
